import { render } from "./minusIcon.svg?vue&type=template&id=87f86e82"
const script = {}
script.render = render

export default script